export default function Avatar() {
  return {}
}
